import React, { useState, useEffect } from 'react';
import './InstallAppGate.css';

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export default function InstallAppGate() {
  const [visible, setVisible] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const ios = isIOS();

  useEffect(() => {
    if (isStandalone()) return;
    try {
      if (sessionStorage.getItem('vtd_install_gate_dismissed')) return;
    } catch (_) { /* ignore */ }
    setVisible(true);
  }, []);

  useEffect(() => {
    const onBip = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', onBip);
    return () => window.removeEventListener('beforeinstallprompt', onBip);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      sessionStorage.setItem('vtd_install_gate_dismissed', '1');
    } catch (_) { /* ignore */ }
  };

  const handleInstall = async () => {
    if (ios) {
      window.location.href = '/appdownload';
      return;
    }
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      if (outcome === 'accepted') {
        setTimeout(() => { window.location.href = '/chat/user'; }, 600);
      }
      return;
    }
    window.location.href = '/appdownload';
  };

  if (!visible) return null;

  return (
    <div className="install-gate" role="dialog" aria-label="Install VTD Astrology app">
      <img
        className="install-gate__logo"
        src={`${process.env.PUBLIC_URL}/images/vtd-sun-logo.svg`}
        alt="VTD Astrology"
      />
      <h2 className="install-gate__title">VTD Astrology</h2>
      <p className="install-gate__tagline">Vedic Astrology by Tilak Datta</p>
      <p className="install-gate__notice">
        Your personal space for readings with <em>Tilak garu</em> — message, voice call, and video consultation in one place.
      </p>
      <p className="install-gate__sub">
        Add VTD Astrology to your home screen for the best experience. A quick one-time setup, and you&apos;re ready to connect.
      </p>
      <button type="button" className="install-gate__install" onClick={handleInstall}>
        {ios ? 'Add to Home Screen' : 'Get VTD Astrology App'}
      </button>
      {ios && (
        <div className="install-gate__ios install-gate__ios--show">
          <strong>iPhone / iPad:</strong> Safari → <strong>Share</strong> → <strong>Add to Home Screen</strong>.
        </div>
      )}
      <ul className="install-gate__features">
        <li>💬 Message Tilak garu directly</li>
        <li>📞 Voice &amp; video calls</li>
        <li>🔮 Daily horoscope &amp; readings</li>
      </ul>
      <button type="button" className="install-gate__skip" onClick={dismiss}>
        Browse website only
      </button>
    </div>
  );
}
